// extracted by css-extract-rspack-plugin
export default {"resultLink":"bsRBY","resultLinkWrapper":"WJ6ff"};